import React from 'react';
import {Routes, Route, HashRouter} from 'react-router-dom';
import Home from './pages/Home';
import Features from './pages/Features';
import HowItWorks from './pages/HowItWorks';
import Contact from './pages/Contact';
import TagRouter from './pages/TagRouter';
import SetupScreen from './pages/SetupScreen';
import EditRouter from './pages/EditRouter';
import EditSetup from './pages/EditSetup';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import ReviewsDashboard from './pages/ReviewsDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import './index.css';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/tag" element={<TagRouter />} />
        <Route path="/setup" element={<SetupScreen />} />
        <Route path="/editqr" element={<EditRouter />} />
        <Route path="/edit-setup" element={<EditSetup />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/reviews"
          element={
            <ProtectedRoute>
              <ReviewsDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </HashRouter>
  );
}

export default App;